import React from "react";

import { handleURLChange } from "@safecv/shared/urlParams";

import "./SearchResult.css";

function PlanSearchResult({
  loader,
  searchResults,
  selectedValue,
  selectedSearchResult,
  setSelectedSearchResult,
}) {
  return (
    <>
      {searchResults && (
        <>
          <div className="annotationbar search-header">Results</div>
          <div className="search-wrapper">
            {searchResults.map((element, i) => {
              return (
                <div
                  key={i}
                  className={
                    element.id === selectedSearchResult
                      ? "basicsearch-showbox basicsearch-showbox-active"
                      : "basicsearch-showbox"
                  }
                  onClick={() => {
                    setSelectedSearchResult(element.id);
                  }}
                >
                  <div className={"pageNo"}>{"Page " + element.pageNo}</div>
                  <div className="annotate-msg">
                    {element.annotationSpecificMessage}
                  </div>
                </div>
              );
            })}
            {!loader && searchResults.length === 0 && (
              <div className="no-annotation-msg">
                <span>No search results for "{selectedValue}"</span>
                {handleURLChange({ textId: "", scale: 1 })}
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default PlanSearchResult;
